import { useState } from 'react';
import Icon from './Icon.jsx';

// Where somewhere came from, folded.
//
// This is the one thing on the screen nobody ever needs in a hurry: worth
// reading on the plane, worth nothing at all while working out which terminal
// the ferry leaves from. So it never opens itself, and closed it costs one line.
// That is also why it is a column and not a note — a generic block would sit
// open in the middle of the stop, competing with the plan.

// Prose arrives from an agent as paragraphs separated by a blank line. A single
// newline is wrapping, not a break, so it is folded back into its paragraph
// rather than becoming a stray one-line orphan.
export function paragraphs(text) {
  return String(text ?? '')
    .split(/\n\s*\n+/)
    .map((p) => p.trim().replace(/\s*\n\s*/g, ' '))
    .filter(Boolean);
}

function Prose({ paras }) {
  return (
    <div className="prose">
      {paras.map((p, i) => <p key={i}>{p}</p>)}
    </div>
  );
}

// A section of its own, for a trip or a stop: the heading is the affordance.
// `flat` drops the section wrapper for the cases where it is one entry among
// several under a heading that already exists.
export default function History({ text, title = 'Storia', flat = false }) {
  const [open, setOpen] = useState(false);
  const paras = paragraphs(text);
  if (paras.length === 0) return null;

  const body = (
    <>
      <button className="cathead" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        <Icon name="chevronRight" size={15}
              style={{ rotate: open ? '90deg' : '0deg', color: 'var(--faint)' }} />
        <b>{title}</b>
        {!open && <span className="count">da leggere</span>}
      </button>
      {open && <Prose paras={paras} />}
    </>
  );

  return flat ? <div className="fold">{body}</div> : <section className="section">{body}</section>;
}

// Inside a card, where a whole section would be too much furniture for three
// sentences about a temple.
export function HistoryLine({ text, label = 'Storia' }) {
  const [open, setOpen] = useState(false);
  const paras = paragraphs(text);
  if (paras.length === 0) return null;

  return (
    <>
      <button className="histline" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        <Icon name="chevronRight" size={12}
              style={{ rotate: open ? '90deg' : '0deg' }} />
        {label}
      </button>
      {open && <Prose paras={paras} />}
    </>
  );
}
